import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type PersistedVehiclesListStore = {
  type: 'table' | 'grid'
  setType: (type: 'table' | 'grid') => void
}

export const usePersistedVehiclesListView = create<PersistedVehiclesListStore>()(
  persist(
    (set, get) => ({
      type: 'grid',
      setType: (type: 'table' | 'grid') => set({ type }),
    }),
    {
      name: 'vehiclesListView',
    },
  ),
)

export const useVehiclesListView = (): {
  view: 'table' | 'grid'
  setView: (type: 'table' | 'grid') => void
} => {
  const { type, setType } = usePersistedVehiclesListView((state) => state)
  return {
    view: type,
    setView: setType,
  }
}
